// Components
export { AdditionalCoverageList } from './components/AdditionalCoverage';
export type { AdditionalCoverageListProps } from './components/AdditionalCoverage';
export { AfterTheSwitch } from './components/AfterTheSwitch';
export type { AfterTheSwitchProps } from './components/AfterTheSwitch';
export { ApplyFormFooterWrapper } from './components/ApplyFormFooter';
export {
  ApplyPageLayout,
  ApplyPageLayoutCar,
  WizardHeading,
} from './components/ApplyLayouts/ApplyPageLayout';
export { Avatar } from './components/Avatar';
export type { AvatarProps } from './components/Avatar';
export { Banner } from './components/Banner';
export type { BannerProps } from './components/Banner';
export { CbLogo } from './components/CbLogo';
export { CbMembership } from './components/CbMembership';
export { CheckboxTileLabel } from './components/CheckboxTileLabel';
export { CheckoutContentBlock } from './components/CheckoutContentBlock';
export type { CheckoutContentBlockProps } from './components/CheckoutContentBlock';
export {
  CheckoutTopNotification,
  getDynamicField,
  CheckoutTopNotificationWrapper,
} from './components/CheckoutTopNotification';
export { CommentWithAvatar } from './components/CommentWithAvatar';
export { Countbar } from './components/Countbar';
export type { CountbarProps } from './components/Countbar';
export { DataSummary } from './components/DataSummary';
export type { DataSummaryProps } from './components/DataSummary';
export { DocumentUrl } from './components/DocumentUrl';
export { ExperienceCollectiveReviews } from './components/ExperienceCollectiveReviews';
export { Filters, FiltersWrapper } from './components/Filters';
export type { FilterItem, FiltersProps, Filter } from './components/Filters';
export { FiltersButton } from './components/FiltersButton';
export { FormInput, FormComponent, FormSubmit } from './components/Form';
export { PersonalDataFieldViewer } from './components/FormWidget';
export { withFormProps } from './components/HOCs/withFormProps';
export type { BaseWithFormProps } from './components/HOCs/withFormProps';
export { FormFieldHOC } from './components/HOCs/FormField';
export type {
  FormPropsWithValue,
  FormFieldProps,
} from './components/HOCs/FormField';
export { Help } from './components/Help';
export type { HelpProps } from './components/Help';
export { IbanInput } from './components/IbanInput/IbanInput';
export { AffiliateUrlIcon } from './components/Icons/AffiliateUrlIcon';
export { GreenCheckIcon } from './components/Icons/GreenCheckIcon';
export { RedCancelIcon } from './components/Icons/RedCancelIcon';
export { BluePredicatenIcon } from './components/Icons/BluePredicatenIcon';
export { YellowQuestionMarkIcon } from './components/Icons/YellowQuestionMarkIcon';
export { GreenPredicatenIcon } from './components/Icons/GreenPredicatenIcon';
export { InfoBlock } from './components/InfoBlock';
export {
  TemplateParagraph,
  TemplateWrapper,
} from './components/InnerPersonalData/TemplateParagraph';
export type { TemplateParagraphProps } from './components/InnerPersonalData/TemplateParagraph';
export { LabelWithFieldname } from './components/LabelWithFieldname';
export type { EmailOptionalProps } from './components/EmailOptional';
export { LogoInsurance } from './components/LogoInsurance';
import { FormFieldHOC } from './components/HOCs';
import { MainCoverageSection as _MainCoverageSection } from './components/MainCoverage/Section';
export const MainCoverageSection = FormFieldHOC(_MainCoverageSection as any);
export { MainCoverageBlock } from './components/MainCoverage/Block';
export type { MainCoverageBlockProps } from './components/MainCoverage/Block';
export { MainCoveragePrice } from './components/MainCoverage/Price';
export { MobileLayover } from './components/MobileLayover';
export { BasePageLayout, PageLayout } from './components/PageLayout';
export type { PageLayoutProps } from './components/PageLayout';
export { OverviewPageLoader } from './components/Pages/OverviewPageLoader';
export { PercentageBar } from './components/PercentageBar';
export { PriceV2, Price } from './components/Price';
export { PriceCapBanner } from './components/PriceCapBanner';
export { Product, ProductsWrapper } from './components/Product';
export {
  ContractSwitchFaq,
  ListComp,
  PackageComp,
  PackageInformation,
  getCharacteristics,
} from './components/Product/ExpandedPart';
export { NonPurchasableText, Arrow } from './components/Product';
export {
  ProductLogo,
  ProductsNewWrapper,
  CompareCheckboxMobile,
  ConfirmationContent,
} from './components/ProductNew';
export type { InnerModalComponentProps } from './components/ProductNew';
export {
  CostTab,
  DetailsTab,
  HowItWorks,
  OsCostTab,
  ReviewsTab,
  SolarPanelsReviewsTab,
  SwitchTab3P,
  SwitchTabHome,
  SwitchTabOS3P,
} from './components/ProductNew/ExpandedPart';
export { Testoordel } from './components/ProductOverviewModalTriplePlay';
export { ProductProsCons } from './components/ProductProsCons';
export {
  ProductSummary,
  ProductSummaryWrapper,
} from './components/ProductSummary';
export type { ProductSummaryProps } from './components/ProductSummary';
export { ProductUsps } from './components/ProductUsps';
export { PromotionBar } from './components/PromotionBar';
export type { PromotionBarProps } from './components/PromotionBar';
export { ProsCons, ProsConsItem } from './components/ProsCons';
export type { ProsConsItemProps } from './components/ProsCons';
export { HealthRatingReviews } from './components/RatingReviews';
export { Search, SearchWrapper } from './components/Search';
export type { SearchWrapperProps, SearchProps } from './components/Search';
export { SecureConnection } from './components/SecureConnection';
export { SelectWithApiWrapper } from './components/SelectWithAPI';
export { SkeletonBlock, SkeletonWrapper } from './components/Skeletons/index';
export { Sorting } from './components/Sorting';
export type { SortingProps } from './components/Sorting';
export { Spinner } from './components/Spinner';
export { StartWidget, StartWidgetWrapper } from './components/StartWidget';
export { getDisplayedScore, Sustainability } from './components/Sustainability';
export { TabViewWizard } from './components/TabViewWizard';
export type { TabViewWizardProps } from './components/TabViewWizard';
export { TermsList } from './components/TermsList';
export type { TermsListProps } from './components/TermsList';
export { ToggleVisibleProductsCheckbox } from './components/ToggleVisibleProductsCheckbox';
export { TopThreeProductsWrapper } from './components/TopThreeProduct';
export { TopThreeSectionWrapper } from './components/TopThreeSectionWrapper';
export { UserDataSummaryWrapper } from './components/UserDataSummary';
export { Usp } from './components/Usp';
export type { UspProps } from './components/Usp';
export { Window } from './components/Window';
export type { WindowProps } from './components/Window';
export { CompareSelect } from './components/comparison/CompareSelect';
export type { CompareSelectProps } from './components/comparison/CompareSelect';
export { ExperienceManager } from './components/comparison/ExperienceManager';
export type { ExperienceManagerProps } from './components/comparison/ExperienceManager';
export { ProductComparisonContainerWrapper } from './components/comparison/ProductComparisonContainer';
export {
  AffiliateDataProvider,
  InnerModalForAffiliates,
} from './components/modals/InnerModalForAffiliates';

export { MailMeThisOverview } from './components/modals/MailMeThisOverview';
export type { MailMeThisOverviewProps } from './components/modals/MailMeThisOverview';
export {
  ArrowComp,
  CustomAccordion,
  ModalWithAccordion,
} from './components/modals/ModalWithAccordion';
export type { ModalWithAccordionProps } from './components/modals/ModalWithAccordion';
export {
  ModalWithStepsWrapper,
  ModalWithSteps,
} from './components/modals/ModalWithSteps';
export type {
  ModalWithStepsWrapperProps,
  ModalWithStepsProps,
} from './components/modals/ModalWithSteps';
export { ModalWithCustomContent } from './components/modals/ModalWithCustomContent';
export { ProductModal } from './components/modals/ProductModal/ProductModal';
export { AddressWithContext } from './components/wrappers/Address/AddressWithContext';
export {
  GoToButton,
  GoToButtonIcon,
} from './components/wrappers/Button/GoToButton';
export { SkipButton } from './components/wrappers/Button/SkipButton';
export { SubmitCurrentFormButton } from './components/wrappers/Button/SubmitCurrentFormButton';
export { SubmitModalWithStepsButton } from './components/wrappers/Button/SubmitModalWithStepsButton';
export { CheckboxWrapper } from './components/wrappers/CheckboxWrapper';
export { CheckoutTopNotificationWrapperHTTP } from './components/wrappers/CheckoutTopNotificationWrapperHTTP';
export { PersonalData as PersonalData2 } from './components/wrappers/FormWidget/PersonalData';
export { PersonalDataMinimized } from './components/wrappers/FormWidget/PersonalDataMinimized';
export { CheckoutPage } from './components/wrappers/PageLayout/CheckoutPage';
export { CheckoutPageGraph } from './components/wrappers/PageLayout/CheckoutPageGraph';
export { ComparisonPage } from './components/wrappers/PageLayout/ComparisonPage';
export { LoadingPage } from './components/wrappers/PageLayout/LoadingPage';
export type { LoadingPageProps } from './components/wrappers/PageLayout/LoadingPage';
export { OfferPage } from './components/wrappers/PageLayout/OfferPage';
export { OverviewPageNew } from './components/wrappers/PageLayout/OverviewPageNew';
export { OverviewPage } from './components/Pages/OverviewPage';
export { PostcodeFieldWrapper } from './components/wrappers/PostcodeFieldWrapper';
export { SubmitCurrentFormBtnWrapper } from './components/wrappers/SubmitCurrentFormBtnWrapper';
export type { SubmitCurrentFormBtnWrapperProps } from './components/wrappers/SubmitCurrentFormBtnWrapper';
export {
  Separator,
  sendCustomEvent,
  ApplyPageWizard,
  MembershipWarning,
} from './components/wrappers/TabViewWizard/ApplyPageWizard';
export { DynamicForm } from './components/wrappers/Wizard/DynamicForm';
export { LayoutElement as DynamicLayoutElement } from './components/wrappers/Wizard/DynamicForm';
export { AccountHolder } from './components/wrappers/inputs/BasicInput/AccountHolder';
export { FirstName } from './components/wrappers/inputs/BasicInput/FirstName';
export { Initials } from './components/wrappers/inputs/BasicInput/Initials';
export { LastName } from './components/wrappers/inputs/BasicInput/LastName';
export { BasicInputWrapper } from './components/wrappers/inputs/BasicInputWrapper';
export {
  CheckboxGroupWrapper,
  CheckboxGroupWrapperApi,
} from './components/wrappers/inputs/CheckboxGroupWrapper';
export type { CheckboxGroupWrapperProps } from './components/wrappers/inputs/CheckboxGroupWrapper';
export { CheckboxWrapper as CustomCheckboxWrapper } from './components/wrappers/inputs/CheckboxWrapper';
export { CustomRadioGroupWrapper } from './components/wrappers/inputs/CustomRadioGroupWrapper';
export { UnitInputWrapper } from './components/wrappers/inputs/UnitInputWrapper';
export {
  TileCheckboxGroup,
  TileRadioGroup,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  RadioCard,
  UnitInput,
  EmailOptional,
  BasicInput,
  Select,
  NoValidationInput,
  DateInput,
} from './components/wrappers/inputs/withFormField';
// TODO: Refactor how this is exported and imported
export * as Inputs from './components/wrappers/inputs/withFormProps';
export type { SelectOption } from './components/wrappers/inputs/withFormProps';
export { CrossSellingBlock } from './components/CrossSellingBlock';
export { CrossSellingBlockWrapper } from './components/CrossSellingBlockWrapper';
export { PopoverV2 } from './components/PopoverV2';
export { ProductOverviewModalTriplePlay } from './components/ProductOverviewModalTriplePlay/ProductOverviewModalTriplePlay';
export { LayoverCostOverview } from './components/layovers/LayoverCostOverview';
export type { LayoverCostOverviewProps } from './components/layovers/LayoverCostOverview';
export {
  CarPremiumContext,
  CarPremiumProvider,
} from './context/car-premium-context';
export { FiltersSortingWrapper } from './components/FiltersSorting';
export { OurAdvice } from './components/OurAdvice';
// Funnels
export { COMPARATOR_TYPE, PRODUCT_TYPE } from './funnels';
export type { CommentWithAvatarProps } from './components/CommentWithAvatar';
export type {
  CheckoutTopNotificationWrapperProps,
  CheckoutTopNotificationProps,
} from './components/CheckoutTopNotification';
export type { SubmitProps } from './components/Form';
export type { WithFormProps } from './components/HOCs/withFormProps';
export type { MainCoveragePriceProps } from './components/MainCoverage/Price';
export { AdditionalInfo } from './components/ProductNew/AdditionalInfo';
export { DiscountTile, CompareCheckboxDesktop } from './components/ProductNew';
export { RatingReviews } from './components/RatingReviews';
export { ButtonCard } from './components/ButtonCard';
export { getBigProductFeature } from './components/ProductNew';
export { OsLogo } from './components/OsLogo';
export { TariffsTabHome } from './components/ProductNew/ExpandedPart/tabs/TariffsTab/Home';
export { Wizard } from './components/Wizard';
export { TruncatedText } from './components/TruncatedText';
export { Field } from './components/wrappers/inputs/Field';
export { TableAccordionRow } from './components/comparison/TableAccordionRow';
export type { TableAccordionRowProps } from './components/comparison/TableAccordionRow';
export { Sections } from './components/Sections';
export { RotatePhone } from './components/RotatePhone';
export type { RotatePhoneProps } from './components/RotatePhone';
export { ReviewsCarousel } from './components/ReviewsCarousel';
export type { ReviewsCarouselProps } from './components/ReviewsCarousel';
export { ReviewCriteriaTable } from './components/ReviewCriteriaTable';
export type { ReviewCriteriaTableProps } from './components/ReviewCriteriaTable';
export { ReviewCard } from './components/ReviewCard';
export { AddressDisplay } from './components/AddressDisplay';
export type { ReviewCardProps } from './components/ReviewCard';
export { RadioGroupWrapper } from './components/wrappers/inputs/RadioGroupWrapper';
export type { RadioGroupWrapperProps } from './components/wrappers/inputs/RadioGroupWrapper';
// Utils
export { usePriceMode } from './utils/hooks';
export {
  scrollToTop,
  formatPrice,
  isLargeDesktop,
  isMobile,
  getCalculateSessionId,
  useCoveragesWithValue,
  useHandleSubmitClick,
  sanitizeObject,
  isMobileXs,
  getCookie,
  setCookie,
  generateUUID,
  getAnalyticsSessionIdCookieName,
} from './utils/global';
export {
  contentToAccordionItems,
  getAdditionalDefinition,
  carCoveragesMapping,
} from './utils/hardcodedDataTransformers';
export { getLabel } from './utils/translations';
export { parseProductFieldData } from './utils/product';
export type { Attributes, PriceMode } from './utils/product';
export { onClick } from './utils/product';
export {
  Mobile,
  Desktop,
  LargeDesktop,
  TableAndDektop,
  Portrait,
  Landscape,
  MobileTableSmallDesktop,
} from './utils/breakpoint';
